
import { useState, useEffect } from "react";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";

interface BiographyInputProps {
  value: string | null;
  onChange: (value: string) => void;
  maxLength?: number;
}

export const BiographyInput = ({ 
  value, 
  onChange, 
  maxLength = 120 
}: BiographyInputProps) => {
  const [charCount, setCharCount] = useState(0);

  useEffect(() => {
    setCharCount(value?.length || 0);
  }, [value]);

  const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    const newValue = e.target.value;
    if (newValue.length <= maxLength) {
      onChange(newValue);
      setCharCount(newValue.length);
    }
  };

  return (
    <div className="space-y-2">
      <Label className="flex items-center justify-between">
        <span>Biografia</span>
        <span className={`text-sm ${charCount >= maxLength ? 'text-red-500' : 'text-gray-400'}`}>
          {charCount}/{maxLength}
        </span>
      </Label>
      <Textarea
        value={value || ''}
        onChange={handleChange}
        placeholder="Escreva uma breve descrição sobre você... (máximo de 120 caracteres)"
        className="min-h-[100px] bg-gray-800 border-gray-700"
      />
    </div>
  );
};
